import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import HeroDetail from "../../components/catalog/hero/HeroDetail/HeroDetail";
import SectionBreadcumb from "../../components/catalog/sections/SectionBreadcumb/SectionBreadcumb";
import SectionRecommended from "../../components/catalog/sections/SectionRecommended/SectionRecommended";
import Layout from "../../components/global/Layout";
import useSWR from "swr";

const fetcher = (url) => fetch(url).then((res) => res.json());

function useBookDetail(id, type) {
  const localStorageKey = "books"; // Key penyimpanan daftar buku

  // Gunakan useMemo untuk memastikan storedBooks tidak berubah di setiap render
  const storedBooks = useMemo(() => {
    const books = localStorage.getItem(localStorageKey);
    return books ? JSON.parse(books) : [];
  }, []);
  // Cari buku berdasarkan id dari storedBooks
  const foundBook = useMemo(
    () => storedBooks.find((book) => book.id === id),
    [storedBooks, id]
  );

  // Hanya fetch data jika buku tidak ditemukan di localStorage
  const { data, error, isValidating } = useSWR(
    foundBook
      ? null
      : `https://api.buku.kemendikdasmen.go.id/${type}/detail/${id}?code=GuruSejahtera2025`,
    fetcher,
    {
      refreshInterval: 18000000, // Re-fetch setiap 5 Jam
      dedupingInterval: 18000000, // Cegah fetching ulang dalam 5 Jam
      revalidateOnFocus: false, // Jangan revalidate saat window fokus kembali
      revalidateOnReconnect: false,
    }
  );

  // Gunakan data dari localStorage jika ada, jika tidak gunakan hasil fetch dari API
  const book = foundBook ?? data?.data ?? [];
  const loadingBook = isValidating;

  // Simpan hasil fetch ke localStorage setelah mendapatkan data dari API
  useEffect(() => {
    if (data?.results) {
      const updatedBooks = [
        ...storedBooks.filter((b) => b.id !== id),
        data.data,
      ]; // Update list tanpa duplikasi
      localStorage.setItem(localStorageKey, JSON.stringify(updatedBooks));
    }
  }, [data, id, storedBooks]);

  return { book, errorBook: error, loadingBook };
}

function useRecommendBooks(id, type) {
  // random number 1-8
  let randomNumber = Math.floor(Math.random() * 8) + 1;
  const { data, error, isValidating } = useSWR(
    `https://api.buku.kemendikdasmen.go.id/${type}/book?code=GuruSejahtera2025&page=${randomNumber}&per_page=4`,
    fetcher,
    {
      refreshInterval: 18000000, // Re-fetch setiap 5 Jam
      dedupingInterval: 18000000, // Cegah fetching ulang dalam 5 Jam
      revalidateOnFocus: false, // Jangan revalidate saat window fokus kembali
      revalidateOnReconnect: false,
    }
  );

  const recommendBooks = data?.data ?? [];
  const loadingRecommendBooks = isValidating ?? false;

  return { recommendBooks, errorRecommendBooks: error, loadingRecommendBooks };
}

const DetailHasilPenilaian = () => {
  const token = localStorage.getItem("user_token");
  const { id } = useParams();

  // Get query params type
  const searchParams = new URLSearchParams(window.location.search);
  const type = searchParams.get("type");

  const { recommendBooks, loadingRecommendBooks } = useRecommendBooks(id, type);
  const { book, loadingBook } = useBookDetail(id, type);

  return (
    <Layout>
      {book?.length !== 0 || loadingBook ? (
        <>
          <SectionBreadcumb
            category={'buku_sekolah_penggerak'}
            level={book?.level}
            title={book?.title}
            slug={book?.id}
          />
          <HeroDetail
            id={book?.id}
            token={token}
            slug={book?.slug}
            image={book?.cover_image}
            bookType="pdf"
            title={book?.title}
            publisher={book?.publisher?.name}
            isbn={book?.isbn}
            edition={book?.edition}
            writer={book?.author}
            attachment={book?.attachment}
            totalDownload={book?.total_download}
            totalRead={book?.total_read}
            totalPlay={book?.total_play}
            loading={loadingBook}
            category={book?.category}
            price={book?.price ?? "-"}
            price_zone_1={book?.book_prices?.[0]?.price ?? "-"}
            price_zone_2={book?.book_prices?.[1]?.price ?? "-"}
            price_zone_3={book?.book_prices?.[2]?.price ?? "-"}
            price_zone_4={book?.book_prices?.[3]?.price ?? "-"}
            price_zone_5A={book?.book_prices?.[4]?.price ?? "-"}
            price_zone_5B={book?.book_prices?.[5]?.price ?? "-"}
            type="penilaian"
            componentType={type}
            
          />
          {recommendBooks.length !== 0 && (
            <SectionRecommended
              recommendBooks={recommendBooks}
              loading={loadingRecommendBooks}
              type="penilaian"
            />
          )}
        </>
      ) : (
        <div className="text-center my-5">
          <img
            width="60"
            src="/assets/image/catalog/not-found.png"
            className="img-fluid"
            alt="Not found"
          />
          <div className="text-center mt-2">
            Buku tidak ditemukan / dalam revisi
          </div>
        </div>
      )}
    </Layout>
  );
};

export default DetailHasilPenilaian;
